import "./About.module.css";
import Header from "@/reusable_sections/Header";
import Story from "./sections/Story";
import WhyChoose from "./sections/WhyChoose";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <Story />
      <WhyChoose />
      <Footer />
    </div>;
}